import Repo from './Repo.js'

export default class WorkplaceRepository extends Repo {
  constructor () {
    super('workplaces')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  getProductRules(id, include) {
    return this.http.get(this.resource + '/' + id + '/product-rules', {include: include}).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getGroupationRules(id, include) {
    return this.http.get(this.resource + '/' + id + '/workplace-groupation-rules', {include: include}).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
